export default "__VITE_ASSET__CXJCaVyV__"